const SUPABASE_URL = "https://drdxdpphyjcexilbqzwn.supabase.co";

const SUPABASE_KEY = "sb_publishable_w3-MY_7sSKAw7MksthrmuQ_zmnHnUUb";

window.supabaseClient = supabase.createClient(
  SUPABASE_URL,
  SUPABASE_KEY
);
/* ==========================================
   BROWSER ID
========================================== */

function getBrowserId() {

  let id = localStorage.getItem("cat_bodega_browser_id");

  if (!id) {

    id = crypto.randomUUID();

    localStorage.setItem("cat_bodega_browser_id", id);

  }

  return id;

}
/* ==========================================
   CHECK DAILY TREAT
========================================== */

async function checkDailyTreat() {

  const sessionId = getBrowserId();

  // Get today's date in New York
  const nyFormatter = new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/New_York",
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  });

  const todayNY = nyFormatter.format(new Date());

  // Get every treat event for this browser
  const { data, error } = await window.supabaseClient
    .from("cat_treat_events")
    .select("created_at")
    .eq("session_id", sessionId);

  if (error) {

    console.error(error);

    return true;

  }

  // Did they already treat a cat today (New York time)?
  const alreadyTreatedToday = data.some(event => {

    const eventDayNY = nyFormatter.format(
      new Date(event.created_at)
    );

    return eventDayNY === todayNY;

  });

  return !alreadyTreatedToday;

}